import React, { useState } from "react";
import themeClasses from "../../themeClasses";

const UserInfoForm = ({ onSuccess, currentTheme }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setSubmitted(true);
    onSuccess(formData);
  };

  return (
    <div>
      {!submitted ? (
        <form onSubmit={handleSubmit} className="space-y-4 p-3">
          <div>
            <label className="block mb-1 font-medium">Name</label>
            <input
              name="name"
              className={`w-full p-2 border rounded ${themeClasses[currentTheme].modalInput}`}
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label className="block mb-1 font-medium">Email</label>
            <input
              name="email"
              type="email"
              className={`w-full p-2 border rounded ${themeClasses[currentTheme].modalInput}`}
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div>
            <label className="block mb-1 font-medium">Phone</label>
            <input
              name="phone"
              type="tel"
              className={`w-full p-2 border rounded ${themeClasses[currentTheme].modalInput}`}
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div>
            <label className="block mb-1 font-medium">Message</label>
            <textarea
              name="message"
              className={`w-full p-2 border rounded ${themeClasses[currentTheme].modalInput}`}
              rows={3}
              value={formData.message}
              onChange={handleChange}
            />
          </div>

          <button
            type="submit"
            className={`border btnSubmit py-2 px-4 rounded-full w-full ${themeClasses[currentTheme].btnSubmit}`}
          >
            Submit
          </button>
        </form>
      ) : (
        <div className="text-center animate-fadeIn ">
          <h2 className="text-3xl py-4 font-bold text-[#54a958]">
            Submitted Successfully!
          </h2>

          <p className="mt-2">
            Thank you! A Merchant Bay representative will contact you shortly.
          </p>
        </div>
      )}
    </div>
  );
};

export default UserInfoForm;
